<template>
  <div class="orbit-terms">
    <slot name="title" v-if="items.length"></slot>
    <component
      v-bind="$attrs"
      :terms="items"
      :status="status"
      :is="params.style"
    ></component>
    <slot name="whenempty" v-if="!items.length && status == 'success'"></slot>
    <div class="load-more-btn-wrapper">
      <button
        v-if="showLoadMore"
        @click="handleLoadMore()"
        class="outlined-button ui-font"
        :class="isFetchingNextPage && 'cursor-not-allowed opacity-50'"
        :disabled="isFetchingNextPage"
      >
        {{ isFetchingNextPage ? "Loading..." : "Load More" }}
      </button>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Util from "@/lib/Util";
import OrbitQuery from "@/lib/OrbitQuery";
import { computed } from "vue";

import TermChips from "@/templates/terms/TermChips.vue";
import TermsFollowList from "@/templates/terms/TermsFollowList.vue";
import TermsFollowChips from "@/templates/terms/TermsFollowChips.vue";

export default {
  props: {
    params: Object,
  },
  components: {
    TermChips,
    TermsFollowList,
    TermsFollowChips,
  },
  setup(props) {
    const requestAPI = (params) => API.requestTerms("categories", params);

    const { items, status, loadMore, hasMorePages, isFetchingNextPage } =
      OrbitQuery(props.params, requestAPI);

    const pagination_style = computed(() =>
      props.params.pagination_style ? props.params.pagination_style : "default",
    );

    const showLoadMore = computed(() => {
      return (
        status.value === "success" &&
        items.value.length &&
        pagination_style.value === "loadMore" &&
        hasMorePages.value
      );
    });

    const handleLoadMore = () => {
      Util.debounceEvent(function () {
        loadMore();
      }, 250);
    };

    return {
      items,
      status,
      showLoadMore,
      handleLoadMore,
      isFetchingNextPage,
    };
  },
};
</script>
